export default { sha: '6978f11894f5dfbe4318f59e4a896d044b584dd4', buildNumber: 'undefined' }
